import { applyMiddleware, createStore, combineReducers } from 'redux';
import { createLogger } from 'redux-logger';
import thunk from 'redux-thunk';
import promise from 'redux-promise-middleware';

import app from './appReducer';
import auth from './authReducer';
import profile from './profileReducer';
import taxonomy from './taxonomyReducer';
import taxonomyName from './taxonomyNameReducer';
import observation from './observationReducer';
import evidence from './evidenceReducer';
import note from './noteReducer';
import person from './personReducer';
import lookupTable from './lookupTableReducer';
import alternateIdentifier from './alternateIdentifierReducer';
import event from './eventReducer';
import location from './locationReducer';

const createAppStore = (initialState = {}) => {
    const reducer =  combineReducers({
        app,
        auth,
        profile,
        taxonomy,
        taxonomyName,
        observation,
        evidence,
        note,
        person,
        lookupTable,
        alternateIdentifier,
        event,
        location
    });

    const middleware = applyMiddleware(promise, thunk, createLogger());

    return createStore(reducer, initialState, middleware);
};

export default createAppStore;
